import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import {downloadImageWithFetch} from "../../../../misc/misc2";
import LookBeforeAfterSlider from "./LookBeforeAfterSlider";
import {loadImagePromise} from "../../../../misc/offlineImagesCache";
import LoadingSpinner from "../../../ui/loadingSpinner";


const LookAIImageOverlayImageContent = (props) => {

  const {aiResults, aiUserFileBlobUrl, opened} = props;
  const [imagesLoaded, setImagesLoaded] = useState([]);

  const activeResult = aiResults.find(aiResult => aiResult.isActive);
  const imageLoaded = activeResult ? imagesLoaded.includes(activeResult.resultImageUrl) : false;

  useEffect(() => {
    const loaded = activeResult ? imagesLoaded.includes(activeResult.resultImageUrl) : false;
    if (!loaded) {
      const loadImages = async () => {
        await loadImagePromise(activeResult.resultImageUrl);
        setImagesLoaded([...imagesLoaded, activeResult.resultImageUrl]);
      }
      loadImages();
    }
  }, [imagesLoaded, activeResult]);

  if (!activeResult) {
    return null;
  }

  return (
    <div className="flex--1 relative u-w-full u-h-full u-rounded-025 overflow-hidden">
      <picture>
        {/*<source srcSet={activeResult.resultImageUrl} media="(min-width: 600px)"/>*/}
        <img className={imageLoaded ? "" : "opacity-0 visibility-hidden"}
             src={activeResult.resultImageUrl} alt="Your Generated Design"/>
      </picture>
      {imageLoaded ? <LookBeforeAfterSlider
        opened={opened}
        backgroundImageUrl={activeResult.sourceImageUrl || aiUserFileBlobUrl}
        overlayImageUrl={activeResult.resultImageUrl}
      /> : (
        <div
          className="u-rounded-025 absolute u-left-0 u-top-0 u-w-full u-h-full overflow-hidden flex flex--center">
          <LoadingSpinner/>
        </div>
      )}
      <Button className="look-ai__overlay-download-button u-pl-2 u-pr-2 u-right-1 u-bottom-1 nowrap"
              onClick={() => downloadImageWithFetch(activeResult.resultImageUrl, "visualizer.png")}>
        <FormattedMessage id="look.ai.overlay.downloadImageButton"/>
      </Button>
    </div>
  )

};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {aiUserFileBlobUrl, aiResults} = store.aiState;

  return {
    aiResults,
    lookOverlayOpened,
    aiUserFileBlobUrl,
  };
};


export default connect(mapStateToProps)(LookAIImageOverlayImageContent)
